import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function equalsPrice(value: any): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const diff = Math.abs(control.value - value);
    return diff > 1 ? { equal: true } : null;
  };
}
